import React from 'react';
import { AuthProvider } from '../../contexts/AuthContext';
import Sidebar from './Sidebar';

export default (props) => {
  return (
    <AuthProvider>
      <Sidebar />
    </AuthProvider>
  );
};